import React from 'react';
import HeaderBanner from "../../../assets/others/all-category-banner.webp";
import { NavLink } from 'react-router-dom';
import { Box } from '@mui/material';

function AllCategoryBanner() {
    return (
        <React.Fragment>
            <Box component="img" src={HeaderBanner} useMap="#image-map" alt="all Category Banner"
                sx={{
                    minWidth: "100%"
                }} />
            <map name="image-map">
                <NavLink to="/card-list?category=apparel">
                    <area alt="apparel" title="apparel" coords="146,19,282,199" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=footwear">
                    <area alt="footwear" title="footwear" coords="302,18,443,201" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=e-commerce">
                    <area alt="e-commerce" title="e-commerce" coords="456,15,594,199" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=grocery-and-home-needs">
                    <area alt="grocery-and-home-needs" title="grocery-and-home-needs" coords="618,16,756,200" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=accessories">
                    <area alt="accessories" title="accessories" coords="768,15,909,204" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=entertainment">
                    <area alt="entertainment" title="entertainment" coords="936,22,1070,203" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=food">
                    <area alt="food" title="food" coords="1091,20,1232,199" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=gifting">
                    <area alt="gifting" title="gifting" coords="142,209,282,386" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=health--wellness">
                    <area alt="health-wellness" title="health-wellness" coords="307,211,439,385" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=jewellery">
                    <area alt="jewellery" title="jewellery" coords="452,201,600,384" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=mobile--electronics">
                    <area alt="mobile-electronics" title="mobile-electronics" coords="614,207,762,390" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=ott">
                    <area alt="ott" title="ott" coords="771,208,910,386" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=travel">
                    <area alt="travel" title="travel" coords="941,208,1070,388" shape="rect"></area>
                </NavLink>
                <NavLink to="/card-list?category=apparel">
                    <area alt="education" title="education" coords="1086,205,1232,388" shape="rect"></area>
                </NavLink>
            </map>
        </React.Fragment>
    );
}

export default AllCategoryBanner;
